import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';
import RelationSearch from '@/shared/components/input/RelationSearch';
import { CapacityTaskSelect } from '@/shared/components/input/filterInputs/FilterCapacityTaskSelect';
import TeamMultiSelect from '@/shared/components/input/multiselect/TeamMultiSelect';
import CompanyMultiSelect from '@/shared/components/input/multiselect/CompanyMultiSelect';
import LegalEntityMultiSelect from '@/shared/components/input/multiselect/LegalEntityMultiSelect';
import { hasMultipleCompanies } from '@/shared/components/security/HasMultiCompany';
import HasMultipleLegalEntities from '@/shared/components/security/HasMultipleLegalEntities';
import SavedFiltersButton from '@/shared/components/SavedFiltersButton';

import messages from './deviationOverviewMessages';

export const defaultFilters = {
  relationId: null,
  relationName: null,
  mainTaskTemplateId: undefined,
  ownCompanies: [],
  legalEntities: [],
  teams: [],
};

class DeviationOverviewFilters extends PureComponent {
  static propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.shape({
      relationId: PropTypes.string,
      relationName: PropTypes.string,
      mainTaskTemplateId: PropTypes.string,
      ownCompanies: PropTypes.arrayOf(PropTypes.string),
      teams: PropTypes.arrayOf(PropTypes.string),
    }),
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    filters: defaultFilters,
  };

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };
    if (filters !== newFilters) onFilterChange(newFilters);
  };

  relationChanged = item => {
    if (!item || !item.id) {
      this.filterChanged({ relationId: null, relationName: null });
    } else {
      this.filterChanged({
        relationId: item.key,
        relationName: item.label,
      });
    }
  };

  mainTaskChanged = value => {
    this.filterChanged({ mainTaskTemplateId: value || undefined });
  };

  render() {
    const { filters, intl, onFilterChange } = this.props;

    const initRelation = filters.relationId
      ? { key: filters.relationId, label: filters.relationName }
      : null;

    return (
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-3 col-sm-6 margin10B">
            <RelationSearch onChange={this.relationChanged} initialSelectedItem={initRelation} />
          </div>
          <div className="col-lg-3 col-sm-6 margin10B">
            <CapacityTaskSelect
              initialValue={filters.mainTaskTemplateId}
              onChange={this.mainTaskChanged}
              placeholder={intl.formatMessage(messages.AllMainTasks)}
            />
          </div>
          {hasMultipleCompanies() && (
            <div className="col-lg-3 col-sm-6 margin10B">
              <CompanyMultiSelect
                selection={filters.ownCompanies || []}
                onChange={val => this.filterChanged({ ownCompanies: val })}
              />
            </div>
          )}
          <HasMultipleLegalEntities>
            <div className="col-lg-3 col-sm-6 margin10B">
              <LegalEntityMultiSelect
                selection={filters.legalEntities || []}
                onChange={val => this.filterChanged({ legalEntities: val })}
              />
            </div>
          </HasMultipleLegalEntities>
          <div className="col-lg-3 col-sm-6 margin10B">
            <TeamMultiSelect
              selection={filters.teams || []}
              onChange={val => this.filterChanged({ teams: val })}
              idProp="code"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <SavedFiltersButton
              screen="DeviationOverview"
              currentFilters={filters}
              defaultFilters={defaultFilters}
              onFiltersChanged={onFilterChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(DeviationOverviewFilters);
